import {
  ParentBlockSelectField,
  getSourceBlockNameHelperText,
} from '../../../ConfigFields/SelectField';

export function UpdatePatientFormFields() {
  return (
    <ParentBlockSelectField
      fieldName="config.payload"
      label="Patient"
      helperText={getSourceBlockNameHelperText('patient')}
    />
  );
}
